export const workspaces = {
  children: {
    base: 'get:workspace/object/children',
    all: (params: { brandId?: number; parentId?: number | null; type?: string }) =>
      [workspaces.children.base, params] as const,
  },

  shared: {
    base: 'get:workspace/shared',
    all: (params: { brandId?: number }) =>
      [workspaces.shared.base, params] as const,
  },

  filePreview: {
    base: (fileId: number) => `get:workspace/file/preview/${fileId}`,
    one: (params: { fileId: number }) =>
      [workspaces.filePreview.base(params.fileId), params] as const,
  },

  fileSummary: {
    get: (params: { fileId: number }) =>
      [`get:workspace/file/summary/${params.fileId}`, params] as const,
    post: (params: { fileId: number }) =>
      [`post:workspace/file/summary/${params.fileId}`, params] as const,
  },

  fileCitations: (params: { fileId: number }) =>
    ['workspace-file-citations', params] as const,

  folder: {
    base: (folderId: number) => `get:workspace/folder/${folderId}`,
    one: (params: { folderId: number }) =>
      [workspaces.folder.base(params.folderId), params] as const,
  },

  brand: {
    base: (brandId: number) => `get:workspace/brand/${brandId}`,
    one: (params: { brandId: number }) =>
      [workspaces.brand.base(params.brandId), params] as const,
  },

  filePageTags: {
    base: (fileId: number) => `get:workspace/file/${fileId}/page-tags`,
    all: (params: { fileId: number }) =>
      [workspaces.filePageTags.base(params.fileId), params] as const,
  },

  file: (params: { fileId: number }) =>
    ['get:workspaces/files', params] as const,

  files: {
    base: 'get:workspaces/files',
    all: (params?: { brandId?: number; folderId?: number }) =>
      [workspaces.files.base, params ?? {}] as const,
  },

  objects: {
    base: 'get:workspaces/objects',
    all: (params?: Record<string, unknown>) =>
      [workspaces.objects.base, params ?? {}] as const,
  },

  objectChildren: {
    base: 'get:workspace/object/children',
    all: (params: { brandId?: number; folderId?: number | null }) =>
      [workspaces.objectChildren.base, params] as const,
  },

  workbookData: (params: { url: string }) =>
    ['fetch-workbook-data', params] as const,
};
